/**
 * Subtle Google connection-health indicator that wraps the user avatar.
 *
 * - `connected` → soft emerald heartbeat ring around the avatar
 * - `disconnected` → gentle rose pulse ring + tiny status dot top-right
 *
 * The wrapper itself is purely presentational; the avatar element is
 * passed in as `children` so we don't duplicate the Avatar component.
 * A native title attribute provides hover-text without pulling another
 * tooltip primitive in.
 */
import React from 'react';

export const GoogleHealthIndicator = ({ connected, children }) => {
  const ringClass = connected ? 'health-heartbeat' : 'health-warning';
  const title = connected
    ? 'Google services connected — Gmail, Drive & Calendar OK'
    : 'Google services not connected — click to reconnect';

  return (
    <span
      className={`relative inline-flex ${ringClass}`}
      title={title}
      data-testid={connected ? 'google-health-ok' : 'google-health-warn'}
      aria-label={title}
    >
      {children}
      {!connected && (
        <span
          className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-rose-500 ring-2 ring-background"
          data-testid="google-health-warn-dot"
        />
      )}
    </span>
  );
};

export default GoogleHealthIndicator;
